import React, { Component } from "react";
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ACTION_TYPES, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, ARTICLE_COMPONENT_INITIAL_DATA, DATA_TYPE } from "../../../../../../../constants/external-constants";
import { Button } from "react-bootstrap";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../../../../../utils/constant.utils";
import { ConfirmationNotificationModal } from "../../../../../../common/modal/confirmation-modal.component";
import CrudTable from "../../../../../../common/details-table/crud-table.component";
import { InputField } from "../../../../../../common/custom-form/input-filter-component";
import { NotificationModal } from "../../../../../../common/modal/notification-modal.component";
import { articleCatalogueMilestoneActions } from "../../../../../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer";
class ComponentArticle extends Component {
    constructor(props) {
        super(props);
        this.state={
            headerTable:'',
            dataTable:[],
            rateComponent:'',
            category:'',
            percent: null,
            amount: null,
            haveRateComponentError: false,
            haveCategoryError: false,
            haveAmountPercentError: false,
            haveReachMaxLimit: false,
            disabledRateComponents: [], // <-- ADD THIS LINE
            fieldTypes:[
                {
                    name:'RateComponent',
                    type:'text',
                    required:true
                  },{
                    name:'Category',
                    type:'text',
                    required:true
                  },{
                    name:'Amount',
                    type:'number',
                    numberType:'decimal',
                  },{
                    name:'Percent',
                    type:'number',
                    numberType:'decimal',
                  }
            ],
        }
    }

    componentDidMount() {
        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];
            const itemList = (this.props.dataComponent?.length > 0)
                ? this.props.dataComponent
                : ARTICLE_COMPONENT_INITIAL_DATA;
            updatedDataTable.push(itemList);
            this.setState({dataTable: updatedDataTable[0]})
            this.props.FormChange("articleCatalogueMilestoneForm.articleComponent", itemList ?? []);
        })
    }


    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleClickAddBtn = ()=> {
        this.setState({
            showModal:true,
        })
    }

    handleConfirmationModal = (buttonType) => {                  
        if (buttonType === CONFIRMATION_VALUE.Ok) {
                this.handleAddData();
                this.setState(prev => ({
                    showModal: !prev.showModal,                   
                }))
    
            } else {
                this.setState({
                    showModal: false
                });
            }
    }

    handleInputField = (e) =>{
        const { name ,value} = e.target       
        this.setState({[name]: value})
    }
    handleDecimalField = (event) => {
        let { name, value } = event.target;

        // Allow empty input for user experience
        if (value === "") {
            this.setState({ [name]: value });
            return;
        }

        // Validate: Allow only numbers and one decimal point
        if (!/^\d*\.?\d{0,2}$/.test(value)) return;

        // Convert to number (removing leading zeros)
        let numValue = Number(value);

        // Ensure it stays within DECIMAL(18,2) range
        if (numValue > 9999999999999999.99) return;

        // Update state
        this.setState({ [name]: value });
    };
    handleAddData=()=>{
            const { rateComponent, category, percent, amount } = this.state;
            if( this.handleValidateData())
            {
                return
            }
            const capitalizeString = (str) =>
                typeof str === "string" ? str.toUpperCase() : str;

            this.setState((prevState) => {
                const updatedDataTable = [...prevState.dataTable];            
                var newItem=[]
                newItem = {
                    Key: Math.floor(Math.random() * 1000),
                    RateComponent: capitalizeString(rateComponent),
                    Category: capitalizeString(category),
                    Amount: amount,
                    Percent: percent                   
                };
                updatedDataTable.push(newItem);
                this.props.fetchComponentData(updatedDataTable);
                return { dataTable: updatedDataTable };
            });
            this.handleResetField();
            this.handleResetModal();
    }

    handleResetField = () => {
        this.setState({
            rateComponent:'',
            category:'',
            percent: null,
            amount: null,
        })
    }

    handleResetModal = () => {
        this.setState({
            showNotif:false,
            haveError:false,
            haveRateComponentError: false,
            haveCategoryError: false,
            haveAmountPercentError: false,
            modalMessage:""
        })
    }

    handleValidateData = ()=>{
        const { dataTable, rateComponent, category, percent, amount } = this.state;
        const alphanumericUnderscoreRegex = /^[a-zA-Z0-9_]+$/;
        const maxData = 20;
        const dataLength = dataTable.length + 1;
        this.handleResetModal();
        if(dataLength > maxData) {
            this.setState({
                showNotif: true,
                haveReachMaxLimit: true,
                modalMessage: "article_component_max_data"
            });
            return true
        }

        if (rateComponent.includes(" ") || category.includes(" ")) {
            this.setState({
                showNotif: true,
                haveRateComponentError: rateComponent.includes(" ") ? true : false,
                haveCategoryError: category.includes(" ") ? true : false,
                modalMessage: "component_space_character_error"
            });
            return true;
        }

        if (!alphanumericUnderscoreRegex.test(rateComponent) || !alphanumericUnderscoreRegex.test(category)) {
            this.setState({
                showNotif: true,
                haveRateComponentError: !alphanumericUnderscoreRegex.test(rateComponent) ? true : false,
                haveCategoryError: !alphanumericUnderscoreRegex.test(category) ? true : false,
                modalMessage: "component_special_character",
            });
            return true;
        }


        if(percent && amount) {
            this.setState({
                showNotif: true,
                haveAmountPercentError: true,
                modalMessage: "component_article_amount_percent"
            });
            return ["Percent", "Amount"];
        }

        if (dataTable.length !== 0) {
            const alreadyExist = dataTable?.some(
                (item) =>
                    item.RateComponent?.toLowerCase() === rateComponent?.toLowerCase()
            )

            if (alreadyExist) {
                this.setState({
                    showNotif: true,
                    haveRateComponentError: true,
                    modalMessage: "article_component_exist"
                });
                return true
            }
            else {
                this.handleClickAddBtn();
            }
        }
        else {
            this.handleClickAddBtn();
        }
    }

    updateData = (key, newData) => {
        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];

            if (!Array.isArray(updatedDataTable)) return null;

            const index = updatedDataTable.findIndex((item) => item.Key === key);
            if (index === -1) return null;

            const capitalize = (str) => (typeof str === "string" ? str.toUpperCase() : str);

            updatedDataTable[index] = {
                ...updatedDataTable[index],
                ...newData[index],
                RateComponent: capitalize(newData[index]?.RateComponent),
                Category: capitalize(newData[index]?.Category),
            };

            updatedDataTable.sort((a, b) => new Date(a.ValidDateFrom) - new Date(b.ValidDateFrom));

            this.props.fetchComponentData(updatedDataTable);
            return { dataTable: updatedDataTable };
        });
    };

    handleCancel = () => {
        this.handleResetField();
        this.handleResetModal();
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }

    handleDeleteData = (key) => {
        this.setState((prevState) => {
            var updatedDataTable = [...prevState.dataTable];
    
            if (Array.isArray(updatedDataTable)) {
                updatedDataTable = updatedDataTable.filter((x) => x.Key !== key);
            }
            this.props.fetchComponentData(updatedDataTable);
            return { dataTable: updatedDataTable };
        });
    };

    handleTableValidation = (key, items) => {
        const setCombination = new Set();
        const alphanumericUnderscoreRegex = /^[a-zA-Z0-9_]+$/;

        this.setState({
            tableHasError: false,
            haveError: false,
        });

        let currentItem = items.find((item) => item.Key === key);
        if (!currentItem) return [];

        const rateComponent = currentItem.RateComponent?.trim() || "";
        const category = currentItem.Category?.trim() || "";
        const percent = currentItem.Percent;
        const amount = currentItem.Amount;

        // Space validation
        if (rateComponent.includes(" ") || category.includes(" ")) {
            this.setState({
                tableHasError: true,
                showNotif: true,
                haveError: true,
                modalMessage: "component_space_character_error",
            });
            return rateComponent.includes(" ") && category.includes(" ") ? ["RateComponent", "Category"] : rateComponent.includes(" ") ? ["RateComponent"] : ["Category"];
        }

        if (!alphanumericUnderscoreRegex.test(rateComponent) || !alphanumericUnderscoreRegex.test(category)) {
            this.setState({
                tableHasError: true,
                showNotif: true,
                haveError: true,
                modalMessage: "component_special_character",
            });
            return !alphanumericUnderscoreRegex.test(rateComponent) && !alphanumericUnderscoreRegex.test(category) ? ["RateComponent", "Category"] : !alphanumericUnderscoreRegex.test(rateComponent) ? ["RateComponent"] : ["Category"];
        }

        if(percent && amount) {
            this.setState({
                tableHasError: true,
                showNotif: true,
                haveError: true,
                modalMessage: "component_article_amount_percent",
            });
            return ["Percent", "Amount"];
        }

        if (!percent && !amount && !["PASS_THRU", "COUNTRY_VAT", "HW_FEE"].includes(rateComponent.toUpperCase())) {
            this.setState({
                tableHasError: true,
                showNotif: true,
                haveError: true,
                modalMessage: "component_article_amount_percent",
            });
            return ["Percent", "Amount"];
        }

        // Duplicate check across all items (excluding current item's KEY)
        const combinationKey = rateComponent.toLowerCase();
        for (const item of items) {
            if (item.Key === key) continue;
            const combo = item.RateComponent?.trim().toLowerCase();
            if (combo === combinationKey) {
                this.setState({
                    tableHasError: true,
                    showNotif: true,
                    haveError: true,
                    modalMessage: "article_component_exist",
                });
                return ["RateComponent"];
            }
        }
    };

    render(){
       
        const { dataTable, rateComponent, category, percent, amount, haveError, haveReachMaxLimit, haveRateComponentError, haveCategoryError, haveAmountPercentError } = this.state;
        const disabledBtn = false;
        const initialRequired =
            rateComponent === '' ||
            category === '' ||
            ((percent === '' || percent === null) && (amount === '' || amount === null));
        const formula = this.props.articleCatalogueMilestoneForm.formula || "";
        const targetRateComponents = ['PASS_THRU', 'COUNTRY_VAT', 'HW_FEE'];

        let firstThreeKeys = this.state.dataTable?.filter(item => targetRateComponents.includes(item.RateComponent)).map(item => item.Key) || [];

        const formattedList = `[${firstThreeKeys.join(', ')}]`;
        return(
            <>
            <div className="flex-col-2 flex-start capital-uppercase details-modal-form__container">
                <div className="grid-col-2 flex-grow-1">
                    <InputField
                        className="form-control"
                        type="text"
                        label={this.toLocaleLanguage("rate_component").toUpperCase()}
                        inputValue={rateComponent}
                        name="rateComponent"
                        onChange={this.handleInputField}
                        fieldProp='.Props'
                        disabled={this.props.isViewing ?? false}
                        hasError={haveRateComponentError}
                        requiredField={true}
                        maxLength={MAX_LENGTH.inputText}
                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                    />
                    <InputField
                        className="form-control"
                        type="text"
                        label={this.toLocaleLanguage("category").toUpperCase()}
                        inputValue={category}
                        name="category"
                        onChange={this.handleInputField}
                        fieldProp='.Props'
                        disabled={this.props.isViewing ?? false}
                        requiredField={true}
                        hasError={haveCategoryError}
                        maxLength={MAX_LENGTH.inputText}
                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                    />
                    <InputField
                        className="form-control"
                        type="number"
                        label={this.toLocaleLanguage("article_amount").toUpperCase()}
                        inputValue={amount}
                        name="amount"
                        onChange={this.handleDecimalField}
                        fieldProp='.Props'
                        inputType={DATA_TYPE.decimal} 
                        disabled={this.props.isViewing ?? false}
                        hasError={haveAmountPercentError}
                        maxLength={MAX_LENGTH.inputText}
                    />  
                    <InputField
                        className="form-control"
                        type="number"
                        label={this.toLocaleLanguage("percent")}
                        inputValue={percent}
                        name="percent"
                        onChange={this.handleDecimalField}
                        fieldProp='.Props'
                        inputType={DATA_TYPE.decimal}
                        disabled={this.props.isViewing ?? false}
                        hasError={haveAmountPercentError}
                        maxLength={MAX_LENGTH.inputText}
                    />                                                                
                </div>
                {
                this.props.isReadAndWrite? (
                    <div className="add-button-container custom-add-button">
                        <div className="btn-tooltiptext">
                            <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                            <span className="tooltip-text">{this.toLocaleLanguage("cancel_adding_component")}</span>
                        </div>

                        <ConfirmationNotificationModal
                            show={this.state.showModal}
                            message={this.state.updatePlanComponentDetails ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.add_details}
                            title={this.state.updatePlanComponentDetails ? 'Update' : 'Add'}
                            handleModal={this.handleConfirmationModal}
                            customClass={'comment-notification-modal modal-text-bold'}
                        />
                            <div className="tooltip-container">
                                <div className={'btn-tooltiptext'}>
                                    <Button
                                        disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? initialRequired : initialRequired}
                                        onClick={this.handleValidateData}
                                        variant="primary"
                                        className="btn-add"
                                    >
                                        {`${ACTION_TYPES.Add}`}

                                    </Button>
                                    <span className="tooltip-text">{this.toLocaleLanguage("add_component_details")}</span>
                                </div>  
                            </div>
                    </div>
                      ) : null

                    }
            </div>
             <div className="details-table-container table-scroll-280 mt-3"> 
                <CrudTable 
                    dataTable={dataTable}
                    headerTable={this.props.header}
                    fieldType={this.state.fieldTypes}
                    updateData={this.updateData}  
                    handleDeleteData={this.handleDeleteData}
                    customValidation={this.handleTableValidation}
                    haveDeleteAndEditBtn={(this.props.isReadAndWrite ? true : false)}
                    hideDeleteBtnByIndex={formattedList}
                    hideEditBtnByIndex={formattedList}
                    formula={formula}
                    disabledFields={["RateComponent", "Category"]}
                />   
            </div> 
             <NotificationModal
                show={this.state.showNotif}
                title={(haveError || 
                    haveRateComponentError ||
                    haveCategoryError ||
                    haveAmountPercentError ||
                    haveReachMaxLimit) ? 'Error' : 'Success'}
                message={this.toLocaleLanguage(this.state.modalMessage)}
                handleModal={this.handleCloseNotif}
                customClass={'comment-notification-modal notification-footer modal-text-bold confirmation-blur-background'}
            />   
            </>
        )
    }
}

export default withRouter(connect(
    state => {
        const {
            articleCatalogueMilestone
            , translation
            , form: { forms: { articleCatalogueMilestoneForm: { $form } } }
        } = state;
        const { articleCatalogueMilestoneForm } = state.form;
        return {
            articleCatalogueMilestone
            , articleCatalogueMilestoneForm
            , translation
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, articleCatalogueMilestoneActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ComponentArticle));